import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FontIcon, 
    Panel, 
    PanelType, 
    Icon, 
    ActionButton, 
    IconButton, 
    Separator,
    INavLink,
    IPanelStyles,
    mergeStyleSets,
    IButtonStyles,
    ISeparatorStyles,
    // ISearchBoxStyles,
    IIconStyles,
    IContextualMenuItem,
    // ContextualMenuItemType,
    // IContextualMenuListProps,
    Stack,
    StackItem,
    Image,
    // Text,
    // ImageFit,
    // DefaultButton,
    IContextualMenuProps,
    DirectionalHint,
    IContextualMenuStyles,
    Persona,
    PersonaSize,
    PersonaPresence,
} from '@fluentui/react';
import ChangePasswordComponent from '../change-password/change-password.component';
import SelectSpaceComponent from '../select-space/select-space.component';
import { Buffer } from "buffer";

// import ApiService from '../../services/api/api.service';
import useAuthStatus from '../../hooks/auth/AuthHook';

import ItemUsuario from '../../models/ItemUsuario';
// import ItemBusqueda from '../../models/ItemBusqueda';
import ItemCliente from '../../models/ItemCliente';
// import ElementEnum from '../../enums/ElementEnum';

// import workOrderIcon from '../../assets/img48/ordentrabajo_48_neg.png';
// import formIcon from '../../assets/img48/formulario_48_neg.png';
// import masterIcon from '../../assets/img48/maestros_48_neg.png';
// import messageIcon from '../../assets/img48/mensajes_48_neg.png';
// import reportIcon from '../../assets/img48/reporte_48_neg.png';
// import userIcon from '../../assets/img48/usuario_48_neg.png';
// import journalRegistryIcon from '../../assets/img48/reloj_48_neg.png';
import logo from '../../assets/logo-mymov-blanco.png';

const classes = mergeStyleSets({
    navbar: ["navbar navbar-expand-lg", {
        backgroundColor: 'var(--color-primario)',
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        padding: 10,
    }],
    navbarToggler: ["navbar-toggler d-lg-none", {
        marginRight: 10,
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
    }],
    navbarTogglerIcon: {
        color: 'white',
    },
    navbarMobileHeader: {
        backgroundColor: '#666666',
        color: 'white',
        paddingLeft: 10,
        paddingRight: 10,
    },
    navbarNav: ["navbar-nav", {
        backgroundColor: '#ffffff',
    }],
    navbarMobileText: {
        margin: 0,
        padding: 10,
    },
    navbarContainer: {
        flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    navbarSpaceName: {
        fontWeight: 'normal',
        fontSize: '16px',
        color: 'white',
    },
});

const panelStyles : IPanelStyles = {
    root: {
        padding: '0',
        fontSize: '16px',
        width: '20px',
        selectors: {
            button: {
                selectors: {
                    '.ms-Panel-closeButton': {
                        backgroundColor: 'var(--color-primario)',
                        borderRadius: '7px',
                    },
                },
            },
        },
    },
    commands: {
        margin: 0,
    },
    content: {
        padding: 0,
        backgroundColor: '#666666',
    },
    scrollableContent: {
        backgroundColor: '#666666',
        padding: 0,
    },
    navigation: {
        backgroundColor: '#666666',
        alignItems: 'center',
    },
    header: {
        padding: '10px',
    },
    headerText: {
        color: '#ffffff',
    },
    overlay: {},
    hiddenPanel: {},
    main: {},
    contentInner: {},
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: 'rgb(50, 49, 48)',
            },
        },
    },
};

const panelButtonStyles : IButtonStyles = { 
    root: { 
        color: 'black',
        backgroundColor: 'white',
        display: 'block',
        width: '100%',
        selectors: {
            ".ms-Button-icon": { 
                color: "black",
            },
        },
    },
    rootHovered: { 
        color: 'var(--color-primario)', 
        backgroundColor: '#dddddd',
        selectors: {
            ".ms-Button-icon": { 
                color: "var(--color-primario)",
            },
        },
    },
};

const separatorStyles : ISeparatorStyles = {
    root: [{
        selectors: {
            '::before': {
                background: '#666666',
            },
        },
    }],
    content: {},
};

// const searchBoxStyles : ISearchBoxStyles = { 
//     root: { 
//         width: '150%', 
//         border: 'none', 
//     },
// };

const navbarIconButtonStyles : IButtonStyles = {
    root: {
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: 10,
        marginRight: 8,
    },
    rootHovered: {
        backgroundColor: '#ffffff',
        color: 'var(--color-primario)',
    },
    rootPressed: {
        backgroundColor: '#ffffff',
        color: 'var(--color-primario)',
    },
    rootExpanded: {
        backgroundColor: '#ffffff',
        color: 'var(--color-primario)',
    },
    menuIcon: {
        display: 'none',
    },
};

const navbarIconButtonIconStyles : IIconStyles = { 
    root: {},
    imageContainer: { 
        color:'var(--color-primario)',
    },
};

const userMenuStyles : IContextualMenuStyles = {
    root: {
        padding: 10,
        textAlign: 'center',
    },
    title: {},
    container: {},
    header: {
        color: "#000000",
        fontWeight: 'bold',
        fontSize: 18,
    },
    list: {},
    subComponentStyles: {
        callout: {},
        menuItem: {},
    },
};

const userMenuLinkStyles : IButtonStyles = {
    root: {
        color: 'var(--color-primario)',
    },
    rootHovered: {
        color: 'var(--color-primario)',
        textDecoration: 'underline',
    },
    rootPressed: {
        color: 'var(--color-primario)',
    },
    rootFocused: {
        color: 'var(--color-primario)',
    },
};

interface INavbarTopComponentProps {
    user: ItemUsuario;
    onLogout: () => void;
    menuItems: INavLink[];
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const NavbarTopComponent = (props: INavbarTopComponentProps) => {
    const auth = useAuthStatus();
    
    const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);
    // const [searching, setSearching] = useState<boolean>(false);
    // const [searchResults, setSearchResults] = useState<IContextualMenuItem[]>([]);
    const [showSelectSpace, setShowSelectSpace] = useState<boolean>(false);
    const [showChangePassword, setShowChangePassword] = useState<boolean>(false);

    // const searchBoxRef = React.useRef(null);

    const openPanel = useCallback(() : void => {
        setIsPanelOpen(true);
    }, []);

    const onDismiss = useCallback(() : void => {
        setIsPanelOpen(false);
    }, []);

    const navigate = useNavigate();

    const onPanelButtonClick = (menuItem: INavLink) : void => {
        navigate(menuItem.url);
        onDismiss();
    };

    // const onSearch = (newValue: string) : void => {
    //     if (newValue) {
    //         setSearching(true);
    //         ApiService.Post<ItemBusqueda[]>('Configuracion', 'GetBusqueda', props.user, {
    //             Filtro: newValue,
    //         }).then((response: ItemBusqueda[]) => {
    //             setSearchResults(response.map((item: ItemBusqueda, index: number) => {
    //                 return {
    //                     key: index.toString(),
    //                     text: item.Asunto,
    //                     secondaryText: item.Descripcion,
    //                     itemType: ContextualMenuItemType.Normal,
    //                     data: item,
    //                 };
    //             }));
    //             setSearching(false);
    //         }, (error: string) => {
    //             alert(error);
    //             setSearching(false);
    //         });
    //     }
    //     else {
    //         setSearchResults([]);
    //     }
    // };

    // const onClear = () : void => {
    //     setSearchResults([]);
    // };

    // const onItemClick = (item: ItemBusqueda) : void => {
    //     if (item.IdElemento === ElementEnum.WORK_ORDERS) {
    //         navigate(`/main/ordenes-trabajo/?id=${item.Clave}`);
    //     }
    //     else if (item.IdElemento === ElementEnum.FORMS) {
    //         navigate(`/main/formularios/?id=${item.Clave}`);
    //     }
    //     else if (item.IdElemento === ElementEnum.JOURNAL_REGISTRY) {
    //         navigate(`/main/registro-jornada/?id=${item.Clave}`);
    //     }
    //     else if (item.IdElemento === ElementEnum.MASTERS) {
            
    //     }
    //     else if (item.IdElemento === ElementEnum.MESSAGING) {
    //         navigate(`/main/mensajeria/?id=${item.Clave}`);
    //     }
    //     else if (item.IdElemento === ElementEnum.REPORTING) {
    //         navigate(`/main/reporting/?id=${item.Clave}`);
    //     }
    //     else if (item.IdElemento === ElementEnum.USERS) {
            
    //     }
    //     else if (item.IdElemento === ElementEnum.WORKS) {
            
    //     }
    //     else if (item.IdElemento === ElementEnum.DASHBOARD) {
            
    //     }
    // };

    // const renderMenuList = (props?: IContextualMenuListProps) => {
    //     return (
    //         <Stack styles={{
    //             root: {
    //                 maxWidth: 400,
    //                 maxHeight: 400,
    //             },
    //         }}>
    //             {
    //                 props && props.items.map((item: IContextualMenuItem, index: number) => (
    //                     item.data ? (
    //                         <StackItem key={index.toString()}>
    //                             <DefaultButton 
    //                                 onClick={() => onItemClick(item.data)}
    //                                 styles={{
    //                                     root: {
    //                                         display: 'flex',
    //                                         padding: 10,
    //                                         alignItems: 'center',
    //                                         height: 'auto',
    //                                         width: '100%',
    //                                     },
    //                                 }}>
    //                                 <Stack 
    //                                     horizontal={true}
    //                                     styles={{
    //                                         root: {
    //                                             alignItems: 'center',
    //                                         },
    //                                     }}>
    //                                     <StackItem styles={{
    //                                         root: {
    //                                             width: 40,
    //                                             flexShrink: 0,
    //                                         },
    //                                     }}>
    //                                         {
    //                                             (item.data.IdElemento === ElementEnum.WORK_ORDERS) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={workOrderIcon}
    //                                                     alt="Orden de trabajo" />
    //                                             ) : (item.data.IdElemento === ElementEnum.FORMS) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={formIcon}
    //                                                     alt="Formulario" />
    //                                             ) : (item.data.IdElemento === ElementEnum.JOURNAL_REGISTRY) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={journalRegistryIcon}
    //                                                     alt="Registro de jornada" />
    //                                             ) : (item.data.IdElemento === ElementEnum.MASTERS) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={masterIcon}
    //                                                     alt="Maestro" />
    //                                             ) : (item.data.IdElemento === ElementEnum.MESSAGING) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={messageIcon}
    //                                                     alt="Mensaje" />
    //                                             ) : (item.data.IdElemento === ElementEnum.REPORTING) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={reportIcon}
    //                                                     alt="Reporte" />
    //                                             ) : (item.data.IdElemento === ElementEnum.USERS) ? (
    //                                                 <Image
    //                                                     styles={{
    //                                                         root: {
    //                                                             height: 24,
    //                                                             width: 24,
    //                                                         },
    //                                                     }}
    //                                                     imageFit={ImageFit.contain}
    //                                                     src={userIcon}
    //                                                     alt="Usuario" />
    //                                             ) : (
    //                                                 <></>
    //                                             )
    //                                         }
    //                                     </StackItem>
    //                                     <StackItem styles={{
    //                                         root: {
    //                                             textAlign: 'left',
    //                                         },
    //                                     }}>
    //                                         <Text styles={{
    //                                             root: {
    //                                                 fontWeight: 'bold',
    //                                                 textAlign: 'left',
    //                                             },
    //                                         }}>
    //                                             {item.data.Asunto}
    //                                         </Text>
    //                                         <br/>
    //                                         <Text styles={{
    //                                             root: {
    //                                                 textAlign: 'left',
    //                                             },
    //                                         }}>
    //                                             {item.data.Descripcion}
    //                                         </Text>
    //                                     </StackItem>
    //                                 </Stack>
    //                             </DefaultButton>
    //                         </StackItem>
    //                     ) : (
    //                         null
    //                     )
    //                 ))
    //             }
    //         </Stack>
    //     );
    // };

    const onDownloadDesktopClick = (ev?: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) : void => {
        let base64 : string = Buffer.from(`${props.user.IdUsuario}-${props.user.CodigoCliente}-${props.user.Token}-MyMov.msi`, 'utf8').toString('base64');
        window.open(`${(process.env.REACT_APP_API_URL || "")}Home/Descarga/${base64}`, '_blank');
    };

    const onRenderUserMenuItemHeader = (item: IContextualMenuItem, dismissMenu: () => void) : JSX.Element => {
        let user : ItemUsuario = item.data?.user;

        return (
            <Stack>
                <StackItem>
                    <Persona 
                        className='flex-column'
                        initialsColor="#ed6d63"
                        initialsTextColor="#ffffff" 
                        presenceColors={{
                            available: user.ColorEstado, 
                            away: "",
                            busy: "",
                            dnd: "",
                            offline: "",
                            oof: "",
                            background: user.ColorEstado,
                        }}
                        presenceTitle={user.NombreEstado}
                        size={PersonaSize.size56}
                        imageInitials={user.Iniciales}
                        presence={PersonaPresence.online} />
                </StackItem>
                <StackItem>
                    <h5 className='mt-3 fw-bold'>
                        {user.NombreCorto}
                    </h5>
                    <p className='m-0'>
                        {user.IdUsuario}
                    </p>
                </StackItem>
                <StackItem>
                    <hr/>
                </StackItem>
                <StackItem>
                    <p className='m-0'>
                        Estás conectado a
                        <br/>
                        <b>
                            {user.Clientes.find((c: ItemCliente) => c.CodigoCliente === user.CodigoCliente)?.Nombre}
                        </b>
                    </p>
                </StackItem>
            </Stack>
        );
    };

    const onRenderUserMenuItem = (item: IContextualMenuItem, dismissMenu: () => void) : JSX.Element => {
        const onClick = () : void => {
            if (item.onClick) {
                item.onClick();
            }
        };

        return (
            <ActionButton 
                styles={userMenuLinkStyles}
                onClick={onClick}
                text={item.text} />
        );
    };

    const userMenuProps: IContextualMenuProps = {
        directionalHint: DirectionalHint.bottomRightEdge,
        directionalHintFixed: true,
        styles: userMenuStyles,
        items: [
            {
                key: 'header',
                text: '',
                data: {
                    user: props.user,
                },
                onRender: onRenderUserMenuItemHeader,
            },
            { 
                key: 'change-space', 
                text: 'Cambiar de espacio',
                onClick: () => setShowSelectSpace(true),
                onRender: onRenderUserMenuItem,
                className: 'mt-5',
            },
            { 
                key: 'change-password', 
                text: 'Cambiar contraseña',
                onClick: () => setShowChangePassword(true),
                onRender: onRenderUserMenuItem,
            },
            { 
                key: 'download-desktop', 
                text: 'Descargar MyMov Desktop',
                onClick: onDownloadDesktopClick,
                onRender: onRenderUserMenuItem,
            },
            { 
                key: 'logout', 
                text: 'Cerrar sesión',
                onClick: () => props.onLogout(),
                onRender: onRenderUserMenuItem,
                className: 'mt-5',
            },
        ],
    };

    const onSelectCustomer = (customer: ItemCliente) : void => {
        props.setLoading(true);
        auth.changeSpace(props.user, customer.CodigoCliente).then((user: ItemUsuario) => {
            user.Clientes = props.user.Clientes;
            auth.setUser(user);
            window.location.reload();
        }, (error: string) => {
            alert(error);
            props.setLoading(false);
        });
    };

    return (
        <>
            <nav className={classes.navbar}>
                {
                    !props.user.ModoBienvenida ? (
                        <div>
                            <button 
                                onClick={openPanel} 
                                className={classes.navbarToggler}
                                type="button" 
                                data-bs-toggle="collapse" 
                                data-bs-target="#navbarNavAltMarkup" 
                                aria-controls="navbarNavAltMarkup" 
                                aria-expanded="false" 
                                aria-label="Toggle navigation">
                                <FontIcon 
                                    aria-label="IconNavbar" 
                                    iconName="CollapseMenu" 
                                    className={classes.navbarTogglerIcon} />
                            </button>
                            <Panel
                                isOpen={isPanelOpen}
                                onDismiss={onDismiss}
                                type={PanelType.smallFixedNear}
                                customWidth={PanelType.customNear.toString()}
                                closeButtonAriaLabel='X'
                                headerText='MyMov'
                                styles={panelStyles}>
                                <div className={classes.navbarMobileHeader}>
                                    <p>
                                        <b>
                                            {props.user.Nombre}
                                        </b>
                                    </p>
                                    <p>
                                        {props.user.Email}
                                    </p>
                                </div>
                                <div className={classes.navbarNav}>
                                    {
                                        props.menuItems.map((menuItem: INavLink, index: number) =>
                                            <ActionButton
                                                key={index}
                                                styles={panelButtonStyles}
                                                iconProps={{
                                                    iconName: menuItem.icon,
                                                }}
                                                onClick={() => onPanelButtonClick(menuItem)}>
                                                {menuItem.title}
                                            </ActionButton>
                                        )
                                    }
                                    <Separator styles={separatorStyles} />
                                    <p className={classes.navbarMobileText}>
                                        Sesión
                                    </p>
                                    <ActionButton
                                        styles={panelButtonStyles}
                                        iconProps={{
                                            iconName: 'PowerButton',
                                        }}
                                        onClick={() => props.onLogout()}>
                                        Cerrar sesión
                                    </ActionButton>
                                </div>
                            </Panel>
                        </div>
                    ) : (
                        null
                    )
                }
                <div className={classes.navbarContainer}>
                    <div className='d-flex align-items-center ps-2'>
                        <span className="navbar-brand d-inline-block">
                            <Image
                                src={logo}
                                alt="MyMov"
                                height={32} />
                        </span>
                        <span className={classes.navbarSpaceName}>
                            {auth.user?.Clientes.find((c: ItemCliente) => c.CodigoCliente === auth.user?.CodigoCliente)?.Nombre}
                        </span>
                    </div>
                    {/* {
                        !props.user.ModoBienvenida ? (
                            <div className="d-none d-md-block">
                                <SearchBox 
                                    ref={searchBoxRef}
                                    disabled={searching}
                                    styles={searchBoxStyles} 
                                    placeholder="Buscar" 
                                    onSearch={onSearch}
                                    onClear={onClear} />
                                <ContextualMenu
                                    target={searchBoxRef}
                                    useTargetWidth={true}
                                    useTargetAsMinWidth={true}
                                    items={searchResults}
                                    hidden={searching || !searchResults.length}
                                    onDismiss={onClear}
                                    onRenderMenuList={renderMenuList} />
                            </div>
                        ) : (
                            null
                        )
                    } */}
                    <div className="navbar-nav">
                        <div>
                            <IconButton 
                                menuProps={userMenuProps}
                                styles={navbarIconButtonStyles}>
                                <Icon 
                                    styles={navbarIconButtonIconStyles} 
                                    iconName='UserOptional' />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </nav>
            {
                (props.user.Clientes.length && showSelectSpace) ? (
                    <SelectSpaceComponent 
                        customers={props.user.Clientes}
                        onSelectCustomer={onSelectCustomer} />
                ) : (
                    null
                )
            }
            {
                showChangePassword ? (
                    <ChangePasswordComponent 
                        isOpen={true} 
                        onClose={() => setShowChangePassword(false)} />
                ) : (
                    null
                )
            }
        </>
    );
};

export default NavbarTopComponent;

